import { put, fork, call, takeEvery, all, select } from 'redux-saga/effects';
import app from '../../app';
import {
  loadProductCompletion,
  loadProductsByIdsCompletion,
  loadAllLimitProductListCompletion,
  loadAllKillProductListCompletion,
  loadAllGroupProductListCompletion,
  loadAllOverseaProductListCompletion,
  loadXgProductLimitInfoCompletion,
  loadProductCommentListCompletion,
  loadHomeProductSearchListCompletion,
  loadProductPickerCompletion,
  loadRandomGroupProductListCompletion,
  loadRandomProductListCompletion,
  loadPackageProductListCompletion,
} from '../../actions';

export function* watchLoadProduct() {
  yield takeEvery('LOAD_PRODUCT', function*({ productId }) {
    const own = yield select(state => state.own.own);
    const prefix = productId.slice(0, 2);
    let query = [];
    let result;

    if (own) {
      query.push('level=' + own.level);
    }

    if (prefix === 'MS') {
      result = yield call(app.httpFetch, {
        url: `/api/ms/product/${productId}?${query.join('&')}`,
        sync_server_time: true
      });
    } else if (prefix === 'PT') {
      result = yield call(app.httpFetch, {
        url: `/api/pt/product/${productId}?${query.join('&')}`,
      });
    } else if (prefix === 'XG' || prefix === 'XR') {
      const [result1, result2] = yield all([
        call(app.httpFetch, {
          url: `/api/xg/product/${productId}?${query.join('&')}`,
        }),
        call(app.httpFetch, {
          url: `/api/xg/product/${productId}/canBuyNum`,
        }),
      ]);

      result = {};
      result.error = result1.error || result2.error;

      if (!result.error) {
        result.data = {
          ...result1.data,
          xg: result2.data,
        };
      }
    } else if (prefix === 'QQ') {
      query.unshift('code=' + productId);

      result = yield call(app.httpFetch, {
        url: `/api/product/detailGlobal?${query.join('&')}`,
      });
    } else if (productId.indexOf('SSL') !== -1) {
      const SSLResult = yield call(app.httpFetch, {
        url: `/api/ssl/act/${productId}?${query.join('&')}`,
      });
      result = {};
      result.error = SSLResult.error;
      if (!result.error) {
        const { product, activity, game, canCreate } = SSLResult.data;
        result.data = {
          ...product,
          activity,
          game,
          canCreate,
        };
      }
    } else {
      query.unshift('code=' + productId);

      result = yield call(app.httpFetch, {
        url: `/api/product/detail?${query.join('&')}`,
      });
    }

    const commentResult = yield call(app.httpFetch, {
      url: `/api/product/comment/${productId}`,
    });
    if (!commentResult.error) {
      result.data = {
        ...result.data,
        commentInfo: commentResult.data,
      };
    }

    yield put(loadProductCompletion(productId, result.data, result.error));
  });
}

export function* watchLoadXgProductLimitInfo() {
  yield takeEvery('LOAD_XG_PRODUCT_LIMIT_INFO', function*({ productId }) {
    const options = {
      url: `/api/xg/product/${productId}/canBuyNum`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadXgProductLimitInfoCompletion(productId, result.error, result.data)
    );
  });
}

export function* watchLoadProductsByIds() {
  yield takeEvery('LOAD_PRODUCTS_BY_IDS', function*({ productIds }) {
    const options = {
      url: `/api/product/get?codes=${productIds.join(',')}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadProductsByIdsCompletion(productIds, result.data, result.error)
    );
  });
}

export function* watchLoadAllLimitProductList() {
  yield takeEvery('LOAD_ALL_LIMIT_PRODUCT_LIST', function*({ actId }) {
    const options = {
      url: `/api/xg/act/${actId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadAllLimitProductListCompletion(actId, result.error, result.data)
    );
  });
}

export function* watchLoadAllKillProductList() {
  yield takeEvery('LOAD_ALL_KILL_PRODUCT_LIST', function*() {
    const options = {
      url: `/api/ms/topic`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadAllKillProductListCompletion(result.error, result.data));
  });
}

export function* watchLoadAllGroupProductList() {
  yield takeEvery('LOAD_ALL_GROUP_PRODUCT_LIST', function*({ actId }) {
    const options = {
      url: `/api/pt/topic/${actId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadAllGroupProductListCompletion(result.error, result.data));
  });
}

export function* watchLoadAllOverseaProductList() {
  yield takeEvery('LOAD_ALL_OVERSEA_PRODUCT_LIST', function*({ range }) {
    const options = {
      url: `/api/product/indexGlobal?no=${range.location}&size=${range.length}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadAllOverseaProductListCompletion(result.error, result.data));
  });
}

export function* watchLoadProductCommentList() {
  yield takeEvery('LOAD_PRODUCT_COMMENT_LIST', function*({
    productId,
    willReload,
  }) {
    const { list, query } = yield select(
      state => state.mall.product.commentMaster
    );
    let start = 0;

    if (!willReload && list) {
      start = list.length;
    }

    const options = {
      url: `/api/product/comment/list?code=${productId}&start=${start}&size=${query.size}`,
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadProductCommentListCompletion(
        result.error,
        (result.data && result.data.listData) || [],
        (result.data && result.data.count) || 0
      )
    );
  });
}

function* watchLoadHomeProductSearchList() {
  yield takeEvery('LOAD_HOME_PRODUCT_SEARCH_LIST', function*({ willReload }) {
    const { list, query } = yield select(
      state => state.mall.product.productSearch
    );
    let start = 0;

    if (!willReload && list) {
      start = list.length;
    }

    const options = {
      url: `/api/product/index?no=${start}&size=${
        query.size
      }&keyword=${encodeURIComponent(query.keyword)}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadHomeProductSearchListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadProductPicker() {
  yield takeEvery('LOAD_PRODUCT_PICKER', function*({ willReload }) {
    const { list, query } = yield select(state => state.mall.product.picker);
    let start = 0;
    if (!willReload && list) {
      start = list.length;
    }

    const options = {
      url: `/api/product/listForRecipe?start=${start}&size=${
        query.size
      }&name=${encodeURIComponent(query.keyword)}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadProductPickerCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadRandomGroupProductList() {
  yield takeEvery('LOAD_RANDOM_GROUP_PRODUCT_LIST', function*({ willReload }) {
    const { list, query } = yield select(
      state => state.mall.product.randomGroupProducts
    );
    let start = 0;

    if (!willReload && list) {
      start = list.length;
    }

    const options = {
      url: `/api/pt/products?start=${start}&size=${query.size}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadRandomGroupProductListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadRandomProductList() {
  yield takeEvery('LOAD_RANDOM_PRODUCT_LIST', function*({ willReload }) {
    const { list, query } = yield select(
      state => state.mall.product.randomProducts
    );
    let start = 0;

    if (!willReload && list) {
      start = list.length;
    }

    const options = {
      url: `/api/product/randomList?start=${start}&size=${query.size}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadRandomProductListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadPackageProductList() {
  yield takeEvery('LOAD_PACKAGE_PRODUCT_LIST', function*() {
    const options = {
      url: `/api/product/packages`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadPackageProductListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export default function* productSaga() {
  yield all([
    fork(watchLoadProduct),
    fork(watchLoadXgProductLimitInfo),
    fork(watchLoadProductsByIds),
    fork(watchLoadAllLimitProductList),
    fork(watchLoadAllKillProductList),
    fork(watchLoadAllGroupProductList),
    fork(watchLoadAllOverseaProductList),
    fork(watchLoadProductCommentList),
    fork(watchLoadHomeProductSearchList),
    fork(watchLoadProductPicker),
    fork(watchLoadRandomGroupProductList),
    fork(watchLoadRandomProductList),
    fork(watchLoadPackageProductList),
  ]);
}
